/**
 * Hook personalizado para gestionar lógica de retenciones
 * Maneja: cargar códigos, calcular retenciones
 */

import { useState, useCallback } from 'react';
import axios from 'axios';
import Decimal from 'decimal.js';

const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3002') + '/api';

const getAuthHeaders = (empresaId) => {
  const token = localStorage.getItem('token');
  return {
    'empresa-id': empresaId,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const useRetenciones = (empresaId) => {
  const [codigos, setCodigos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Cargar códigos de retención
  const cargarCodigos = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/configuracion/retenciones-2026`,
        { headers: getAuthHeaders(empresaId) }
      );

      const codigosData = response.data.retenciones || response.data.data || [];
      setCodigos(codigosData);
      return codigosData;
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.message;
      setError(errorMsg);
      setCodigos([]);
      return [];
    } finally {
      setLoading(false);
    }
  }, [empresaId]);

  // Calcular retención
  const calcularRetencion = useCallback((tipo, porcentaje, monto) => {
    try {
      const montoDecimal = new Decimal(monto || 0);
      const porcentajeDecimal = new Decimal(porcentaje || 0);
      const retencion = montoDecimal.times(porcentajeDecimal.dividedBy(100));
      return retencion.toFixed(2);
    } catch (err) {
      console.error('Error calculando retención:', err);
      return '0.00';
    }
  }, []);

  // Obtener código por ID
  const obtenerCodigo = useCallback(
    (codigoId) => {
      return codigos.find((c) => c.codigo === codigoId);
    },
    [codigos]
  );

  // Limpiar error
  const limpiarError = useCallback(() => {
    setError(null);
  }, []);

  return {
    codigos,
    loading,
    error,
    cargarCodigos,
    calcularRetencion,
    obtenerCodigo,
    limpiarError,
  };
};
